module.exports = __webpack_public_path__ + "img/slideOne.637e14c4.svg";